import { useLocalStorage } from "@rehooks/local-storage";
import { TENANT_KEY } from "../constants";

export function useTenantSetting() {
  return useLocalStorage(TENANT_KEY);
}
